/* eslint-disable react/forbid-dom-props */
import classnames from 'classnames';
import { isString } from 'lodash';
import React, { useContext, useMemo } from 'react';
import FormControlInfoMessage from '../../utils/FormControlInfoMessage';
import Spinner from '../../utils/Spinner';
import AnimatedTitle from '../base/AnimatedTitle';
import useHelpNoteTitle from '../../utils/Translations/useHelpNoteTitle';
import useLayoutDirection from '../../utils/Translations/useLayoutDirection';
import styles from './ValueView.scss';
import ViewLabelTooltipContext from './ViewLabelTooltipContext';
const ValueView = ({ isMultiline = false, loading = false, label = '', noLabel = false, value = null, emptyValue = null, renderAddon = null, addonClassName, valueClassName, className = '', infoMessage, infoMessageAlign = 'left', title = '', disableTitleTooltip = false, }) => {
    const { direction, isLayoutRTL, startSide } = useLayoutDirection();
    const viewLabelTooltip = useContext(ViewLabelTooltipContext);
    const empty = value === null || value === undefined;
    const hasLabel = !noLabel && label;
    const _title = useMemo(() => {
        if (title) {
            return title;
        }
        if (viewLabelTooltip && noLabel && label) {
            return label;
        }
        if (isString(value)) {
            return value;
        }
        if (isString(emptyValue)) {
            return emptyValue;
        }
        return '';
    }, [emptyValue, title, value, noLabel, label, viewLabelTooltip]);
    const resolvedTooltipTitle = useHelpNoteTitle(_title);
    const wrapperStyle = useMemo(() => renderAddon && isLayoutRTL
        ? {
            marginLeft: '70px',
            marginRight: 0,
        }
        : undefined, [isLayoutRTL, renderAddon]);
    const addonStyle = useMemo(() => isLayoutRTL
        ? {
            left: '-60px',
            right: 'auto',
        }
        : undefined, [isLayoutRTL]);
    return (<div className={classnames('form-group-material', className, {
        'form-group': hasLabel,
        [styles.loading]: loading,
        [styles.withAddon]: renderAddon,
    })} data-layout-direction={direction} dir={direction} style={wrapperStyle}>
      {hasLabel ? (<AnimatedTitle value className={styles.label} placeholder={label}/>) : null}
      <div className={classnames(styles.value, valueClassName, 'captionLabel', startSide === 'right' ? 'text-right' : 'text-left', {
        [styles.multiline]: isMultiline,
        'empty-value': empty && !loading,
    })} title={disableTitleTooltip ? '' : resolvedTooltipTitle}>
        {loading && <Spinner />}
        {!loading && empty && (emptyValue || '')}
        {!loading && !empty && value}
        {renderAddon && (<span className={classnames(styles.addon, addonClassName)} style={addonStyle}>
            {typeof renderAddon === 'function' ? renderAddon() : renderAddon}
          </span>)}
        {infoMessage && (<FormControlInfoMessage additionalClassNames="mt-10" message={infoMessage} messageAlign={infoMessageAlign}/>)}
      </div>
    </div>);
};
export default ValueView;
